// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"baad8536","359":"f7fd6d1c","453":"d855a71b","457":"278dbe7e","530":"fc2784f8","719":"a370d48b","773":"f68a08c7","947":"ca96ebb6","970":"b8ac57df"}[chunkId] + ".chunk.js";
};